import { Button } from "@metricell/smarttoolscore";
import React from "react";

export interface IRegisterPasskeyEmailFormProps {
    userName: string;
}

export const RegisterPasskeyEmailForm: React.FunctionComponent<
    IRegisterPasskeyEmailFormProps
> = (props): React.ReactElement => {
    const handleSubmitClick = async (): Promise<void> => {
        const data = {
            userName: props.userName,
        };

        const apiResponse: Response = await fetch(
            `/Account/SendPasskeyRegisterEmail`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            },
        );

        const responseString: string = await apiResponse.json();

        const obj = await JSON.parse(responseString);
        if (apiResponse.ok) {
            alert("An email is sent to register your passkey ");
        } else {
            alert("" + obj.data);
        }
    };

    return (
        <Button type={`primary`} onClick={handleSubmitClick} fullWidth>
            Register Passkey
        </Button>
    );
};
